<script>
import mixinComponent from '../../../Mixins/mixinComponent'

export default {
  mixins: [mixinComponent],

  methods: {
    download() {
      this.$emit('download')
    },
  },
}
</script>
<template>
  <a
    class="export-button filter-button btn"
    @click="download"
    :data-toast-title="$t('home.export.button')"
    e2e-button="export"
  >
    <i class="fas fa-upload"></i>
  </a>
</template>
